import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import PDatePicker from "vue2-persian-datepicker";
import vSelect from 'vue-select'
import axios from "axios";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import VueTimepicker from "vue2-timepicker";
import VueApexCharts from "vue-apexcharts";
import VueCroppie from "vue-croppie";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "./assets/scss/main.scss";
import "./assets/scss/w3css.css";
import "vue2-timepicker/dist/VueTimepicker.css";
import "croppie/croppie.css";
import "animate.css";
import 'vue-select/dist/vue-select.css';
global.jQuery = require("jquery");
var $ = global.jQuery;
window.$ = $;
Vue.component('v-select', vSelect)
Vue.prototype.$http = axios;
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(VueApexCharts);
Vue.use(VueCroppie);
Vue.config.productionTip = false;
Vue.component("pdatepicker", PDatePicker);
Vue.component("vueTimepicker", VueTimepicker);
Vue.component("apexchart", VueApexCharts);
// Vue.component('highcharts', HighchartsVue)

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
